import React, { useRef } from 'react'
import Header from './Header';
import Routing from '../Navigation/routing';
import { Outlet, Link } from 'react-router-dom';
import Footer from './Footer';
import Gallery from '../pages/Gallery';

const Layout = () => {
    // SCROLL TO GALLERY SECTION
    const galleryRef = useRef(null) //CREATE REF OF THE GALLERY SECTION
    const handleScrollToGallery = () => {
        if (galleryRef.current) {
            galleryRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    };

    // SCROLL TO CONTACT US
    const contactRef = useRef(null) //CREATE REF OF THE CONTACT US
    const handleScrollToContact = () => {
        if (contactRef.current) {
            contactRef.current?.scrollIntoView({ behavior: 'smooth' })
        }
    }


    return (
        <>
            <Header onScrollToGallery={handleScrollToGallery} onScrollToContact={handleScrollToContact} />

            <main>
                {/* <Routing contactRef= {contactRef} galleryRef={galleryRef}  /> */}
                <Outlet/>
            </main>

            <Gallery ref={galleryRef} />

            <Footer ref={contactRef} />
        </>
    )
}

export default Layout